import type { PlayerState } from "./castFollower";

/** What a stall detector takes: the follower's player states, plus Android's ERROR (never stuck). */
export type StallState = PlayerState | "error";

/** Android `StallDetector` default: stuck for this long is a stall. */
export const STALL_MS = 1_500;

/**
 * Port of Android `StallDetector` (com.project.streaming.sync, CastFollowerRunner.kt): your own
 * player stuck (not advancing: paused, buffering, frozen) for `stallMs`; publisher only. An ended
 * player is never stuck: the media finished and stays at its end. `mono` is a monotonic clock.
 */
export class StallDetector {
  private lastPosition: number | null = null;
  private stuckSinceMs: number | null = null;

  constructor(private readonly stallMs: number = STALL_MS) {}

  onReport(positionMs: number, state: StallState, mono: number): void {
    const last = this.lastPosition;
    const moving = state === "playing" && (last == null || positionMs > last);
    this.stuckSinceMs = moving || state === "ended" || state === "error" ? null : (this.stuckSinceMs ?? mono);
    this.lastPosition = positionMs;
  }

  /** The stuck position once `stallMs` passed; the wait then starts again. */
  check(mono: number): number | null {
    const since = this.stuckSinceMs;
    if (since == null) return null;
    if (mono - since < this.stallMs) return null;
    this.stuckSinceMs = mono;
    return this.lastPosition;
  }

  reset(): void {
    this.lastPosition = null;
    this.stuckSinceMs = null;
  }
}
